'use strict';

/* Directives */

var directives = { _all: {} };

directives.register = function(name, func) {
  /* if the app is in loading phase, register in config phase */
  if (name in directives._all) {
    console.error('directive already registered! - ' + name);
    return;
  }
  if (app.register == null) {
    app.config(function() {
      app.register.directive(name, func);
    });
  } else {
    /* if the app is already running just regsiter */
    app.register.directive(name, func);
  }
  directives._all[name] = func;
};

/*
* load all directives that are defined in files*/
directives.load = function(afterFunc) {
  afterFunc();
};

global.directives = directives;

/* all simple directives can go here... */
angular.module('cfn').directive('hasright', [
  '$rootScope',
  'i18nFilter',
  '$dialog',
  'CfnUpgradeRightsDialogService',
  function($rootScope, i18nFilter, $dialog, CfnUpgradeRightsDialogService) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var requiredRight = attrs.hasright,
          clickInterceptor = function(event) {
            var passes = true;
            if (requiredRight) {
              passes =
                passes &&
                CfnUpgradeRightsDialogService.showDialog(requiredRight);
            }
            if (!passes) {
              event.stopImmediatePropagation();
              event.preventDefault();
            }
          };
        element.click(clickInterceptor);
      }
    };
  }
]);

angular.module('cfn').directive('autoheight', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'A',
      scope: { hpercent: '=' },
      link: function(scope, element, attrs) {
        $rootScope.$watch($rootScope.window, function(value) {
          if (scope.heightPercent == undefined) scope.heightPercent = 1.0;
          //console.log("rounding "+scope.heightPercent+" "+$rootScope.window.contentHeight)   ;
          var h = Math.round(
            scope.heightPercent * $rootScope.window.contentHeight
          );
          element.css('height', h + 'px');
        });
      }
    };
  }
]);

angular.module('cfn').directive('fullHeight', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var storedHeight = element.parent().height();
        var last = new Date();
        scope.getParentHeight = function() {
          if (new Date() - last > 5000) {
            // only update once every 5 seconds
            storedHeight = element.parent().height();
            last = new Date();
          }
          return storedHeight;
        };
        scope.$watch('getParentHeight()', function(value) {
          element.css('height', scope.getParentHeight() + 'px');
        });
      }
    };
  }
]);

angular.module('cfn').directive('iconHeader',
  () => {
    return {
      restrict: 'E',
      scope: {
        name: '@',
        title: '@',
        icon: '@',
        fnIcon: '@'
      },
      template: function(element, attrs) {
        if (attrs.icon) {
          return (
              "<table><tr><td valign='middle'>" +
              "<span class='{{icon}}'></span>" +
              '</td>' +
              '<td><h1>{{ title }}</h1></td>' +
              '</tr></table>'
          );
        }
        else if (attrs.fnIcon) {
          return `
            <table><tr><td valign='middle'>
            <fn-icon icon-name="{{ fnIcon }}" size="24"></fn-icon>
            </td>
            <td><h1>{{ title }}</h1></td>
            </tr></table>
          `;
        }
        else {
          return (
              "<table><tr><td valign='middle'>" +
              "<img class='appTitleIcon' ng-src='{{name|iconPath}}black/{{ name | lowercase }}.png'/>" +
              '</td>' +
              '<td><h1>{{ title }}</h1></td>' +
              '</tr></table>'
          );
        }
      }
    };
  }
);

angular.module('cfn').directive('icon', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'E',
      scope: { name: '@', size: '@' },
      link: function(scope, element, attrs) {
        scope.color = 'white';
        scope.opacity = 1;
        if (attrs.color) {
          scope.color = attrs.color;
        }
        if (scope.color == 'black') {
          scope.opacity = 0.8;
        }
      },
      template:
        "<img ng-src='{{name|iconPath}}{{color}}/{{ name| lowercase }}.png' ng-style=\"{'max-height': size+'px', 'max-width': size+'px', opacity: opacity}\"/>"
    };
  }
]);

angular.module('cfn').directive('cfnVertical', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template:
      '<div style="position:relative;"><div class="verticalDiv" style="position:absolute;" ng-transclude></div></div>',
    link: function(scope, element, attr) {
      ang.callAfter(function() {
        var elm = element.children(':first');
        var w = elm.width();
        var h = elm.height();
        element.width(h);
        element.height(w);
        element.css('top', w + 'px');
      });

      //elm.height(w);
    }
  };
});

// override the default input to update on blur
angular.module('cfn').directive('ngModelOnblur', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elm, attr, ngModelCtrl) {
      if (attr.type === 'radio' || attr.type === 'checkbox') return;

      elm
        .unbind('input')
        .unbind('keydown')
        .unbind('change');
      elm.bind('blur', function() {
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(elm.val());
        });
      });
    }
  };
});

/**
ASC 21.2.2019 i dont see any sense in this directive, it affects the orignal ng-blur event, commented it out
angular.module('cfn').directive('ngBlur', [
  '$parse',
  '$log',
  function($parse, $log) {
    return function(scope, elm, attrs) {
      elm.blur(function(event) {
        var parentGet = $parse(attrs['ngBlur']);

        //TODO: this actually looks still very very fragile
        var fn = parentGet(scope.$parent);
        // fn();
      });
    };
  }
]);
*/

angular.module('cfn').directive('cfnInclude', [
  '$http',
  '$templateCache',
  '$compile',
  function($http, $templateCache, $compile) {
    return {
      restrict: 'E',
      scope: {
        src: '@',
        ctrl: '&'
      },
      link: function(scope, element, attr) {
        var passedScope;
        if (scope.ctrl && scope.ctrl() && scope.ctrl().getScope) {
          passedScope = scope.ctrl().getScope();
        }

        $http
          .get(scope.src, {
            cache: $templateCache
          })
          .then(function(response) {
            element.append(angular.element(response.data));
            if (passedScope) {
              $compile(element.contents(), false, 499)(passedScope);
            } else {
              $compile(element.contents(), false, 499)(scope);
            }
          });
      }
    };
  }
]);

angular.module('cfn').directive('cfnHelpIcon', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'E',
      scope: {
        flag: '='
      },
      template:
        '<span class="farmnet-help" ' +
        'class="helpIcon" ' +
        'ng-mouseenter="flag=true" ' +
        'ng-mouseleave="flag=false" ' +
        '/>'
    };
  }
]);

// calls the ngInit again if this watch changed
angular.module('cfn').directive('fnReInitWatch', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'A',

      link: function(scope, element, attrs) {
        //console.debug("reinitwatch",scope,attrs);
        scope.$watch(attrs.fnReInitWatch, function(value) {
          //  console.debug("changed!!",value);

          scope.$eval(attrs.ngInit);
        });
      }
    };
  }
]);
